import React from 'react'
import PropTypes from 'prop-types'
import { weekdays, getStandardTime } from '@helpers/string-helper'
import { styled } from '@mui/material'
import '../../assets/css/components/store-locator/store-info.sass'

const StyledStoreDetails = styled('div')(({ theme }) => ({
  padding: '8px',
  a: {
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '22px',
    textDecorationLine: 'underline',
    color: '#0053A0',
    marginBottom: '10px',
    display: 'inline-block',
    outline: 'none',
  },
  [theme.breakpoints.down('md')]: {
    a: {
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
    },
  },
}))

const StyledStoreName = styled('h2')(({ theme }) => ({
  textTransform: 'uppercase',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '22px',
  marginBottom: '10px',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
    lineHeight: '16px',
    marginBottom: '8px',
  },
}))

const StyledHours = styled('p')(({ theme }) => ({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#00854A',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
    lineHeight: '16px',
  },
}))

const StoreInfo = ({ selectedMarker }) => {
  let hours
  if (selectedMarker.hours && !selectedMarker.hours.regularHours) {
    hours = selectedMarker.hours
  } else if (selectedMarker.hours && selectedMarker.hours.regularHours) {
    hours = selectedMarker.hours.regularHours
  }
  const currentDay = weekdays[new Date().getDay()]
  return (
    <StyledStoreDetails>
      <StyledStoreName className="store-name">{selectedMarker.name}</StyledStoreName>
      <div className="storeAddress">
        {/* These links are statically rendered inside a radar marker popup, so they can't be StrapiLink or RTGLinkV2 components. */}
        {/* For now commenting out the data layer push and gtm tracking */}
        <a
          href={`https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination=${selectedMarker.lat},${selectedMarker.lng}`}
          title={`Directions to ${selectedMarker.name}`}
          // data={{
          //   url: `https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination=${selectedMarker.lat},${selectedMarker.lng}`,
          //   title: `Directions to ${selectedMarker.name}`,
          //   category: 'store locator',
          //   action: 'Directions store map click',
          //   label: 'Directions to store',
          // }}
          target="_blank"
          className="store-address-link"
        >
          {selectedMarker.title}
          <br />
          {selectedMarker.city}, {selectedMarker.state} {selectedMarker.zip}
        </a>
        <br />
        {(selectedMarker.phone || selectedMarker.phoneNumber) && (
          <a
            href={`tel:${(selectedMarker.phone ? selectedMarker.phone : selectedMarker.phoneNumber).replace('/', '-')}`}
            title={`Call ${selectedMarker.name}`}
            // data={{
            //   url: `tel:${(selectedMarker.phone ? selectedMarker.phone : selectedMarker.phoneNumber).replace(
            //     '/',
            //     '-',
            //   )}`,
            //   title: `Call ${selectedMarker.name}`,
            //   category: 'store locator',
            //   action: 'Call store map click',
            //   label: 'Call store',
            // }}
          >
            {(selectedMarker.phone ? selectedMarker.phone : selectedMarker.phoneNumber).replace('/', '-')}
          </a>
        )}
        {hours && (
          <div>
            {hours &&
              hours.map(hour => {
                const day = hour.day ? hour.day : weekdays[hour.dayIndex]
                return (
                  day === currentDay && (
                    <StyledHours className="hour" key={hour.day}>
                      {hour.openTime && hour.closeTime
                        ? `Open Today ${getStandardTime(hour.openTime)} to ${getStandardTime(hour.closeTime)}`
                        : 'Closed Today'}
                    </StyledHours>
                  )
                )
              })}
          </div>
        )}
      </div>
    </StyledStoreDetails>
  )
}

StoreInfo.propTypes = {
  selectedMarker: PropTypes.shape({
    city: PropTypes.string,
    hours: PropTypes.oneOfType([
      PropTypes.shape({
        regularHours: PropTypes.array,
      }),
      PropTypes.array,
    ]),
    lat: PropTypes.any,
    lng: PropTypes.any,
    name: PropTypes.string,
    phone: PropTypes.string,
    phoneNumber: PropTypes.string,
    state: PropTypes.string,
    title: PropTypes.string,
    zip: PropTypes.string,
  }),
}

export default StoreInfo
